import Link from 'next/link'
import Image from 'next/image'
import UserAuthStatusButton from '@/components/UserAuthStatusButton'
import GlobalNavigation from '@/components/GlobalNavigation'

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 shadow-sm">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <nav className="flex items-center space-x-4">
          <Link href="/" className="flex items-center space-x-2">
            <Image
              src="/writely-logo.png"
              alt="Writely"
              width={87}
              height={25}
              priority
            />
          </Link>
          <GlobalNavigation />
        </nav>
        <div className="flex items-center space-x-4">
          <UserAuthStatusButton />
        </div>
      </div>
    </header>
  )
}
